import { MetricsKey } from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsTypes";

const getMetricsAggregation = (
  type: "max" | "min" | "sum",
  inlineMetrics: string,
  frequencyValue?: string,
) => {
  let splitData = inlineMetrics.split(",");

  if (frequencyValue === "7d") {
    splitData = splitData?.slice(splitData.length - 7, splitData.length);
  }

  const data = splitData.map((point) =>
    isNaN(+point) || point === "" ? null : +point,
  );

  return (
    data?.reduce((acc, value) => {
      if (value === null || acc === null) {
        return acc;
      }

      if (type === "sum") {
        return value + acc;
      }

      if (type === "max") {
        return Math.max(value, acc);
      }

      if (type === "min") {
        return Math.min(value, acc);
      }

      return acc;
    }, 0) ?? null
  );
};

const getMax = (inlineMetrics: string, frequencyValue?: string) =>
  getMetricsAggregation("max", inlineMetrics, frequencyValue);

const getMin = (inlineMetrics: string, frequencyValue?: string) =>
  getMetricsAggregation("min", inlineMetrics, frequencyValue);

const getSum = (inlineMetrics: string, frequencyValue?: string) =>
  getMetricsAggregation("sum", inlineMetrics, frequencyValue);

const aggregationByMetricType: Record<
  MetricsKey,
  (inlineMetrics: string, frequencyValue?: string) => number | null
> = {
  cpu_max: getMax,
  cpu_cores: getMax,
  cpu_percent: getMax,
  total_connection_sum: getSum,
  all_request_sum: getSum,
  processed_bytes: getSum,
  memory_used_percent: getMax,
  mem_used_percent_max: getMax,
  memory_used_bytes: getMax,
  mem_available_percent_min: getMin,
};

export const getAggregationByMetricType = (
  type: MetricsKey,
  inlineMetrics?: string,
  frequencyValue?: string,
) => {
  const aggregationFn = aggregationByMetricType[type];

  if (!aggregationFn || !inlineMetrics) {
    return null;
  }

  return aggregationFn(inlineMetrics, frequencyValue);
};
